import React from 'react';
import { Countdown } from '../Countdown';
import { CtaButton } from '../CtaButton';
import { Splashes } from '../Splashes';
export function FinalClose({
  onCta
}: {
  onCta: () => void;
}) {
  return <section className="relative w-full overflow-hidden bg-ink-soft px-5 py-12 sm:py-16" data-id="element-100" data-mp="2efh7p1ntaxo5">
      <Splashes className="opacity-60" data-id="element-101" data-mp="2j6z9tt1kn4ap" />
      <div className="relative mx-auto max-w-2xl text-center" data-id="element-102" data-mp="2j80jbt2xviqb">
        <h2 className="font-display text-3xl leading-tight text-white sm:text-5xl" data-id="element-103" data-mp="2o626oq7ee47l">
          Este es tu último domingo <span className="text-magenta" data-id="element-104" data-mp="2t3kegd9oide0">improvisando</span>
        </h2>

        <div className="mt-6 rounded-xl border border-red-500/30 bg-[#350910]/70 px-4 py-6" data-id="element-105" data-mp="2x6grlogg9hak">
          <p className="font-display text-lg uppercase text-white sm:text-2xl" data-id="element-106" data-mp="3251rtnvpc0z0">⏳ El precio de lanzamiento cierra en:</p>
          <div className="mt-4" data-id="element-107" data-mp="12szbgmidjmpk"><Countdown data-id="element-108" data-mp="12thfw6f6x78k" /></div>
        </div>

        <div className="mt-7 rounded-xl border border-lime/40 bg-lime/5 p-5" data-id="element-109" data-mp="12uk76fgfdbp0">
          <p className="text-xs font-extrabold uppercase tracking-widest text-lime" data-id="element-110" data-mp="17riyyrcm96k1">Dos opciones disponibles</p>
          <div className="mt-3 grid gap-3 text-left sm:grid-cols-2" data-id="element-111" data-mp="1tl13gwcngqns">
            <div className="rounded-lg border border-white/15 bg-ink-card p-4" data-id="element-112" data-mp="1oqwvqavk8eln">
              <p className="font-display text-xl text-white" data-id="element-113" data-mp="1krxub091ezyy">Megapack Zumba Pro</p>
              <p className="mt-1 font-display text-3xl text-lime" data-id="element-114" data-mp="1fsbeqk5ql7mz">$19.900 <span className="font-sans text-xs text-white/50" data-id="element-115" data-mp="1fpp060kfhrv9">ARS</span></p>
            </div>
            <div className="rounded-lg border border-lime bg-lime/5 p-4" data-id="element-116" data-mp="2cfy7o83lq7vo">
              <p className="font-display text-xl text-white" data-id="element-117" data-mp="28hs233ei1ycc">Megapack + Elite</p>
              <p className="mt-1 font-display text-3xl text-lime" data-id="element-118" data-mp="23gb5hk31sy1k">$27.990 <span className="font-sans text-xs text-white/50" data-id="element-119" data-mp="1yi9nz3l9t6s7">ARS</span></p>
              <p className="mt-1 text-xs font-bold text-magenta" data-id="element-120" data-mp="1ykdp5drsbros">Ahorrás $19.990</p>
            </div>
          </div>
        </div>

        <div className="mt-6" data-id="element-121" data-mp="n3dy0lh6biwc">
          <CtaButton variant="lime" className="w-full max-w-md" onClick={onCta} data-id="element-122" data-mp="n22tgjfwm746">
            🔥 Elegir mi Megapack
          </CtaButton>
        </div>
      </div>
    </section>;
}